import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as firebase from 'firebase/app'
import 'firebase/database'
firebase.initializeApp({
  databaseURL: 'https://baron-itf.firebaseio.com'
})

type State = {
  statusCount: {
    [key: string]: number
  }
  watchingRef: firebase.database.Reference | null
}

const state: State = {
  statusCount: {},
  watchingRef: null
}

const store = new Vuex.Store({
  state,
  mutations: {
    updateStatusCount(state, statusCount) {
      state.statusCount = statusCount
    }
  },
  actions: {
    requestStatusCount() {
      if (this.state.watchingRef) this.state.watchingRef.off()

      const ref = firebase.database().ref(`analytics/perRange/statusCount`)
      ref.once('value', snapshot => {
        store.commit('updateStatusCount', snapshot.val())
        console.info('[statusCount] updated')
      })
      ref.on('child_changed', snapshot => {
        if (!snapshot.key) return
        const statusCount = { ...this.state.statusCount }
        statusCount[snapshot.key] = snapshot.val()
        this.commit('updateStatusCount', statusCount)
      })

      this.state.watchingRef = ref
    }
  }
})

export default store
